import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import useAlert from "../hooks/useAlert";

const AuthContext = React.createContext({
  isLoggedIn: false,
  accessLevel: 0,
  memberId: 0,
  memberName: "",
  onLogout: () => {},
  onLogin: () => {},
});

export const AuthContextProvider = (props) => {
  const [isLoggedIn, setLoginStatus] = useState(false);
  const [accessLevel, setAccessLevel] = useState(0);
  const [memberName, setMemberName] = useState("");
  const [memberId, setMemberId] = useState(0);
  // const [logoutMessage, setlogoutMessage] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["MSMTAMember"]);
  const { setAlert } = useAlert();

  var logoutMessage = "";

  useEffect(() => {
    // console.log(`Running useEffect`);
    if(cookies.MSMTAMember){
      const storedUserLoginStatus = localStorage.getItem('isLoggedIn');
      // console.log(`storedUserLoginStatus is ${storedUserLoginStatus}`);
      if (storedUserLoginStatus){
          const loginDetails = {
              id: localStorage.getItem('memberId'),
              accessType: localStorage.getItem('accessLevel'),
              fname: localStorage.getItem('memberName'),
              reloading: true
          };
          // console.log(`Calling loginAction with ${JSON.stringify(loginDetails)}`);
          loginAction(loginDetails);
      }
    }else {
      const storedUserLoginStatus = localStorage.getItem('isLoggedIn');
      if(storedUserLoginStatus){
        // setlogoutMessage('You were logged out due to inactivity.', () => {logoutAction();})
        logoutMessage = 'You were logged out due to inactivity.';
        logoutAction();
        
      }
    }
  })


  const loginAction = (params) => {
    // console.log(`This is params object: ${JSON.stringify(params)}`);
    setCookie(
      "MSMTAMember",
      `${params.id}|${params.accessType}|${params.fname}`,
      { path: "/", domain: ".msmta.org", maxAge: 28800 }
    );
    setLoginStatus(true);
    setAccessLevel(params.accessType);
    setMemberId(params.id);
    setMemberName(params.fname);
    localStorage.setItem('isLoggedIn', true);
    localStorage.setItem('accessLevel', params.accessType);
    localStorage.setItem('memberName', params.fname);
    localStorage.setItem('memberId', params.id);
  };

  const logoutAction = () => {
    console.log(`This is message: ${logoutMessage}`)
    removeCookie("MSMTAMember", { path: "/", domain: ".msmta.org" });
    setLoginStatus(false);
    setAccessLevel(0);
    setMemberId(0);
    setMemberName("");
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('accessLevel');
    localStorage.removeItem('memberName');
    localStorage.removeItem('memberId');
    // console.log("You were successfully logged out! Have a nice day.");
    if(logoutMessage === ""){
      logoutMessage = "You were successfully logged out! Have a nice day.";
    }
    setAlert(logoutMessage, 'success');
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        onLogout: logoutAction,
        onLogin: loginAction,
        memberName: memberName,
        memberId: memberId,
        accessLevel: accessLevel
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
